import { render, staticRenderFns } from "./select-defaultValue-editor.vue?vue&type=template&id=143b8f6c&scoped=true"
import script from "./select-defaultValue-editor.vue?vue&type=script&lang=js"
export * from "./select-defaultValue-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b8f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143b8f6c')) {
      api.createRecord('143b8f6c', component.options)
    } else {
      api.reload('143b8f6c', component.options)
    }
    module.hot.accept("./select-defaultValue-editor.vue?vue&type=template&id=143b8f6c&scoped=true", function () {
      api.rerender('143b8f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-select/select-defaultValue-editor.vue"
export default component.exports